<template>
  <div>
    <b-container>
      <b-row class="justify-content-center mt-5">
        <b-col class="text-center" cols="10">
          <h2 class="text-muted d-inline">
            <font-awesome-icon icon="clipboard-list" class="mr-2" />
            {{ client.company }}
          </h2>

          <hr />
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col>
          <b-table
            :items="projects"
            :fields="projectFields"
            striped
            borderless
            stacked="md"
          >
            <template v-slot:cell(title)="data">
              <b-link
                :to="{
                  name: 'Project',
                  params: {
                    clientId: client.id,
                    projectId: data.item.id,
                  },
                }"
                class="btn btn-sm btn-pill btn-primary"
              >
                {{ data.item.title }}
              </b-link>
            </template>

            <template v-slot:cell(isActive)="data">
              <font-awesome-icon
                :icon="data.item.isActive ? 'check-circle' : 'times-circle'"
                :class="data.item.isActive ? 'text-success' : 'text-danger'"
              />
            </template>
            <template v-slot:cell(actions)="data">
              <b-link
                class="btn btn-sm btn-danger mr-2"
                @click="delProject(data.item.id)"
                ><font-awesome-icon icon="edit" class="mr-2" />DELETE
              </b-link>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      loading: true,
      token: this.$store.state.login.token,

      apiUrl: this.$store.state.api.url,
      frontUrl: `${process.env.VUE_APP_FRONTURL}/#/quiz`,

      projectFields: [
        {
          key: "title",
          label: "Project title",
        },
        {
          key: "isActive",
          label: "Status",
          /*formatter: (value) => {
            return value === true ? "Active" : "Inactive";
          },*/
        },
        {
          key: "cards",
          label: "Cards",
        },
        {
          key: "matchup_length",
          label: "Matchup Length",
        },
        {
          key: "questions_sequence",
          label: "Questions sequence",
        },
        {
          key: "results",
          label: "Results",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  computed: mapState({
    client: (state) => state.api.selectedClient,
    projects: (state) => state.api.selectedClientProjects,
  }),
  created() {
    let clientId = this.$route.params.clientId;

    this.$store.dispatch("api/fetchClientProjects", clientId);
    this.$store.dispatch("api/fetchClient", clientId);
  },
  methods: {
    delProject: function(projectId) {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deleteProject", projectId)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
  },
};
</script>
